import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
  template: require('./router-menu.html'),
})
export class RouterMenu extends Vue {
}



// WEBPACK FOOTER //
// src/components/router-menu.ts